import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Image, Alert, Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import { Store } from "../../Store";
import ToastIt from "../../components/Toast";
// import ConfirmIt from "../../Utils/ConfirmIt";
import { CSVLink } from "react-csv";
import ConfirmIt from "../../Utils/ConfirmIt";
// import MTN from '../Products/MTN'
// import { useLocation, useNavigate} from "react-router-dom";

const AdminProducts = () => {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo, baseUrl, products } = state;

  // const navigate = useNavigate();
  // const location = useLocation();

  const [selNetwork, setSelNetwork] = useState('');
  const [NowProducts, setNowProducts] = useState([]);
  // const [showModal, setShowModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [newProduct, setNewProduct] = useState({
    network: "",
    image: "",
    packages: [],
    status: "available",
  });
  // const [showConfirm, setShowConfirm] = useState(false);
  // const [alertMessage, setAlertMessage] = useState("");
  // const [OrderToProcess, setOrderToProcess] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [variance, setVariance] = useState("");

  const [packageInput, setPackageInput] = useState({
    offer: "",
    priceCustomer: "",
    priceAgent: "",
  });
  const [editPackageIndex, setEditPackageIndex] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isImageValid, setIsImageValid] = useState(false);
      const [showConfirm, setShowConfirm] = useState(false);
      const [alertMessage, setAlertMessage] = useState("");
      const [confirmAction, setConfirmAction] = useState(null);
  const [csvData, setCsvData] = useState([]);

  // const activeTab = location.pathname.includes('mtn') ? 'mtn' : location.pathname.includes('telecel') ? 'telecel' :location.pathname.includes('afa')?'afa': 'airteltigo';
  // const [key, setKey] = React.useState('MTN'); 

  useEffect(() => {
    if (products && products.length > 0) {
      setNowProducts(products);
    } else {
      setNowProducts([]);
    }
  }, [products]);

  useEffect(() => {
    // console.log('selNet',selNetwork)
    const selectedProduct = products.find((product) => product.network === selNetwork);
    if (selectedProduct) {
      setCurrentProduct(selectedProduct);
      setNewProduct({
        network: selectedProduct.network,
        image: selectedProduct.image,
        packages: selectedProduct.packages,
        status: selectedProduct.status,
      });
    } else {
      setCurrentProduct(null);
      setNewProduct({
        network: selNetwork,
        image: '',
        packages: [],
        status: 'available',
      });
    }
  }, [products, selNetwork]);

  // console.log('newPro', newProduct)
  // get product based on key
  // useEffect(() => {
  //   const getProducts = NowProducts.filter(product => product.network === key);
  //   const product = getProducts[0];
  //   if (product) {
  //     setCurrentProduct(product);
  //   }else{
  //     setCurrentProduct(null);
  //   }
  // }, [key, NowProducts]);

  const updateProductStatus = async (productId, status) => {
    setShowConfirm(true);
    setAlertMessage(`Are you sure you want to mark this product as ${status}?`);
    setConfirmAction(()=>async () => {
      setShowConfirm(false);
      try {
        const { data } = await axios.put(
        `${baseUrl}/product/${productId}/status`,
        { status },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      setNowProducts(
        NowProducts.map((product) =>
          product._id === productId
            ? { ...product, status: data.status }
            : product
        )
      );
      setToastMessage("Product status updated successfully");
      setVariance("success");
      setShowToast(true);
    } catch (error) {
      setToastMessage("Error updating product status:", error);
      setVariance("danger");
      setShowToast(true);
    }
  });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 100 * 1024; // 100KB
    if (file.size > maxSize) {
      setErrorMessage(
        "Image size exceeds 100KB. Please upload a smaller image."
      );
      setIsImageValid(false);
      return;
    }
    // if (file) {
    //   setThisImage(URL.createObjectURL(file));
    //   setimgFileName(file.name);
    //   setNewProduct({ ...newProduct, image: thisImage, fileName: imgFileName });
    //   setErrorMessage("");
    //   setIsImageValid(true);
    // }

    const reader = new FileReader();
    reader.onloadend = () => {
      setNewProduct({ ...newProduct, image: reader.result });
      setErrorMessage("");
      setIsImageValid(true);
    };
    reader.readAsDataURL(file);
  };

  // const handleAddPackage = () => {
  //   if (!currentProduct) {
  //     console.error("Current product is null");
  //     return;
  //   }
  //   if (!isNaN(packageInput.priceCustomer) && !isNaN(packageInput.priceAgent)) {
  //     const updatedPackages = [
  //       ...currentProduct.packages,
  //       {
  //         offer: packageInput.offer,
  //         priceCustomer: packageInput.priceCustomer,
  //         priceAgent: packageInput.priceAgent,
  //       },
  //     ];
  //     setCurrentProduct({ ...currentProduct, packages: updatedPackages });
  //     setPackageInput({ offer: "", priceCustomer: "", priceAgent: "" });
  //   } else {
  //     setErrorMessage("Price must be a number");
  //   }
  // };

  const handleAddPackage = () => {
    if (!isNaN(packageInput.priceCustomer) && !isNaN(packageInput.priceAgent)) {
      if (editPackageIndex !== null) {
        const updatedPackages = [...newProduct.packages];
        updatedPackages[editPackageIndex] = {
          offer: packageInput.offer,
          priceCustomer: packageInput.priceCustomer,
          priceAgent: packageInput.priceAgent,
        };
        setNewProduct({ ...newProduct, packages: updatedPackages });
        setEditPackageIndex(null);
      } else {
        // for new packages
        setNewProduct({
          ...newProduct,
          packages: [
            ...newProduct.packages,
            {
              name: packageInput.offer,
              priceCustomer: packageInput.priceCustomer,
              priceAgent: packageInput.priceAgent,
            },
          ],
        });
      }
      setPackageInput({ offer: "", priceCustomer: "", priceAgent: "" });
    } else {
      setErrorMessage("Price must be a number");
    }
  };

  // const handleEditPackage = (index) => {
  //   const pkg = newProduct.packages[index];
  //   setPackageInput({
  //     offer: pkg.offer,
  //     priceCustomer: pkg.priceCustomer,
  //     priceAgent: pkg.priceAgent,
  //   });
  //   setEditPackageIndex(index);
  // };

  const handleRemovePackage = (index) => {
    const updatedPackages = newProduct.packages.filter((_, i) => i !== index);
    setNewProduct({ ...newProduct, packages: updatedPackages });
  };
  
  const handleSaveChanges = async () => {
    try {
      if (currentProduct) {
        // Update existing product
        const { data } = await axios.put(
          `${baseUrl}/product/${currentProduct._id}`,
          newProduct,
          {
            headers: { Authorization: `Bearer ${userInfo.token}` },
          }
        );
        let updateProduct = data.product;
        ctxDispatch({ type: "UPDATE_PRODUCTDATA", payload: updateProduct });
        // setNowProducts(
        //   NowProducts.map((product) =>
        //     product._id === currentProduct._id
        //   ? data.product
        //   : product
        //   )
        // );
        setToastMessage("Product updated successfully");
        setVariance("success");
        setShowToast(true);
      } else {
        // Add new product
        const { data } = await axios.post(
          `${baseUrl}/product/create`,
          newProduct,
          {
            headers: { Authorization: `Bearer ${userInfo.token}` },
          }
        );

        let updateProduct = data.product;
        ctxDispatch({ type: "UPDATE_PRODUCTDATA", payload: updateProduct });
        // setNowProducts([...products, data.product]);
        setToastMessage("Product created successfully");
      }
      setVariance("success");
      setShowToast(true);
      // setShowModal(false);
      setCurrentProduct(null);
      setNewProduct({
        network: "",
        image: "",
        packages: [],
        status: "available",
      });
      // window.location.reload();
    } catch (error) {
      setToastMessage("Error saving product:", error);
      setVariance("danger");
      setShowToast(true);
    }
  };

  // const handleUpdateProduct = (product) => {
  //   // return
  //   setCurrentProduct(product);
  //   setNewProduct({
  //     network: product.network,
  //     image: product.image,
  //     packages: product.packages,
  //     status: product.status,
  //   });
  //   setShowModal(true);
  // };

  // const handleDelete = (ProductID) => {
  //   setAlertMessage("Are you sure you want to delete this product?");
  //   setOrderToProcess(ProductID);
  //   setShowConfirm(true);
  // };

  // DELETE PRODUCT
  // const confirmActionHandler = async () => {
  //   try {
  //     await axios.delete(`${baseUrl}/product/${OrderToProcess}`, {
  //       headers: { Authorization: `Bearer ${userInfo.token}` },
  //     });
  //     setNowProducts(
  //       NowProducts.filter((product) => product._id !== OrderToProcess)
  //     );
  //     setVariance("success");
  //     setToastMessage("Product deleted successfully");
  //     setShowToast(true);
  //   } catch (error) {
  //     setVariance("danger");
  //     setToastMessage(`Error deleting product:', ${error.message}`);
  //     setShowToast(true);
  //   }
  //   setShowConfirm(false);
  // };

  // const isFormValid = () => {
  //   return newProduct.network && isImageValid && newProduct.packages.length > 0;
  // };

 // Add a function to set csvData when the Export to CSV button is clicked
  const handleExportToCSV = () => {
    setCsvData(
      NowProducts.map((product) => ({
        Network: product.network,
        Image: product.image,
        Packages: product.packages
          .map(
            (pkg) => `${pkg.name} - ${pkg.priceCustomer} - ${pkg.priceAgent}`
          )
          .join(", "),
        Status: product.status,
      }))
    );
    return csvData;
  };

  // const ProductTab = ({product}) => {
  //   // const offerRefs = useRef([]);
  //   // const priceCustomerRefs = useRef([]);
  //   // const priceAgentRefs = useRef([]);

  //   const handleOfferChange = (index, value) => {
  //     const packages = [...product.packages];
  //     packages[index].offer = value;
  //     setCurrentProduct({ ...product, packages });
  //   };

  //   const handlePriceCustomerChange = (index, value) => {
  //     const packages = [...product.packages];
  //     packages[index].priceCustomer = value;
  //     setCurrentProduct({ ...product, packages });
  //   };

  //   const handlePriceAgentChange = (index, value) => {
  //     const packages = [...product.packages];
  //     packages[index].priceAgent = value;
  //     setCurrentProduct({ ...product, packages });
  //   };
  //   return (
  //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
  //     {/* <div style={{ width: '50vw', maxWidth: '80vw' }}> */}
  //     <div className="col-9 col-md-6">
  //       <div className="text-center">
  //       <h3 className="text-center">{product.network.toUpperCase()} PRODUCTS</h3>
  //       STATUS: 
  //       <Form.Control
  //         name="status"
  //         as="select"
  //         value={product.status}
  //         style={{
  //         // backgroundColor: product.status === "available" ? "green" : "red",
  //         color: "white",
  //         width: '12vw', display: 'inline-block'
  //         }}
  //         onChange={(e) => updateProductStatus(product._id, e.target.value)}
  //       >
  //         <option value="available">Available</option>
  //         <option value="out of stock">Out of Stock</option>
  //       </Form.Control>
  //       &nbsp;   
  //       ICON: <Image src={product?.image} alt={product?.network} thumbnail width="50px" />
  //       <p>Offer || Customer price || Agent price</p>
  //       </div>

  //       <Form>
  //       <Form.Group controlId="packages">
  //         {product?.packages.map((pkg, index) => (
  //         <div key={index} className="d-flex">
  //           <Form.Control
  //           type="text"
  //           placeholder="Offer"
  //           title="offer"
  //           value={pkg.offer || ""}
  //           onChange={(e) => handleOfferChange(index, e.target.value)}
  //           />
  //           <Form.Control
  //           type="number"
  //           placeholder="Customer Price"
  //           title="Customer Price"
  //           value={pkg.priceCustomer || ""}
  //           onChange={(e) => handlePriceCustomerChange(index, e.target.value)}
  //           />
  //           <Form.Control
  //           type="number"
  //           placeholder="Agent Price"
  //           title="Agent Price"
  //           value={pkg.priceAgent || ""}
  //           onChange={(e) => handlePriceAgentChange(index, e.target.value)}
  //           />
  //           <Button
  //           variant="link"
  //           onClick={() => handleRemovePackage(index)}
  //           >
  //           x
  //           </Button>
  //         </div>
  //         ))}
  //         <Button
  //         variant="info"
  //         size="sm"
  //         className="m-1"
  //         onClick={handleAddPackage}
  //         >
  //         {" "}
  //         Add
  //         </Button>
  //         <div>
  //         <Button variant="success" className="w-100" onClick={handleSaveChanges}>
  //           {" "}
  //           Save Changes
  //         </Button>
  //         </div>
  //       </Form.Group>
  //       </Form>
  //     </div>
  //     </div>
  //   );
  // };

  return (
    <Container className="py-1 mt-3">
      <h3 className="text-center text-primary">PRODUCT MANAGEMENT</h3>
      <hr/>
                <Form >
                   {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                  <Row>
                  <Form.Group  as={Col} xs={12} md={4}  controlId="network">
                    {/* <Form.Label>NETWORK</Form.Label> */}
                    <Form.Control
                      as="select"
                      // value={newProduct.network}
                      // onChange={(e) => setNewProduct({ ...newProduct, network: e.target.value })}
                      value={selNetwork}
                      onChange={(e) => setSelNetwork(e.target.value)}
                    >
                      <option value="">Select Network</option>
                      <option value="MTNup2u">MTNUp2U</option>
                      <option value="MTNme2u">MTNMe2U</option>
                      <option value="MTNexpress">MTN Express</option>
                      {/* <option value="MTN4">MTN 4</option> */}
                      <option value="AirtelTigo">AirtelTigo</option>
                      <option value="AT-ishare">AT iShare</option>
                      <option value="Telecel">Telecel</option>
                      <option value="Airtime">Airtime</option>
                      <option value="AFA">AFA</option>
                      <option value="WAEC">WAEC SERVICES</option>
                    </Form.Control>
                  </Form.Group>
                  <Form.Group  as={Col} xs={12} md={4} controlId="pimage">
                    {/* <Form.Label>ICON</Form.Label> */}
                    <Form.Control
                      type="file"
                      onChange={handleImageChange}
                    />
                    {newProduct.image && (
                      <Image src={newProduct.image} alt="Product" roundedCircle width="50px" height='auto' className="mt-2" />
                    )}
                  </Form.Group>
                  <Form.Group  as={Col} xs={12} md={4} controlId="pimage">
                    <Form.Label>STATUS:</Form.Label>{' '}
                    <Form.Control
                    name="status"
                    as="select"
                    // value={product.status}
                    style={{
                    // backgroundColor: newProduct?.status === "available" ? "green" : "red",
                    // color: "white",
                    width: '12vw', display: 'inline-block'
                    }}
                    onChange={(e) => updateProductStatus(currentProduct._id, e.target.value)}
                  >
                    <option value="available" defaultValue>Available</option>
                    <option value="out of stock">Out of Stock</option>
                  </Form.Control>
                  </Form.Group>
                  <Form.Group controlId="packages">
                    <Form.Label>Packages</Form.Label>
                    {newProduct.packages.map((pkg, index) => (
                <div key={index} className="d-flex">
                  <Form.Control
                    type="text"
                    placeholder="Offer"
                    title="offer"
                    value={pkg.offer || ""}
                    onChange={(e) => {
                      const packages = [...newProduct.packages];
                      packages[index].offer = e.target.value;
                      setNewProduct({ ...newProduct, packages });
                    }}
                  />
                  <Form.Control
                    type="number"
                    placeholder="Customer Price"
                    title="Customer Price"
                    value={pkg.priceCustomer || ""}
                    onChange={(e) => {
                      const packages = [...newProduct.packages];
                      packages[index].priceCustomer = e.target.value;
                      setNewProduct({ ...newProduct, packages });
                    }}
                  />
                  <Form.Control
                    type="number"
                    placeholder="Agent Price"
                    title="Agent Price"
                    value={pkg.priceAgent || ""}
                    onChange={(e) => {
                      const packages = [...newProduct.packages];
                      packages[index].priceAgent = e.target.value;
                      setNewProduct({ ...newProduct, packages });
                    }}
                  />
                  {/* <Button
                    variant="link"
                    onClick={() => handleEditPackage(index)}
                  >
                    Edit
                  </Button> */}
                  <Button
                    variant="link"
                    onClick={() => handleRemovePackage(index)}
                    >
                    x
                  </Button>
                </div>
              ))}
              <br/>
              <Button
                variant="success"
                size="sm"
                className="m-1"
                onClick={handleAddPackage}
                disabled={!newProduct.network || !isImageValid}
              >
                {" "}
                {editPackageIndex !== null ? "Update package" : "Add package"}{" "}
              </Button>

        {/* {currentProduct  */}
          {/* ? */}
          <div>
          <Button variant="primary" className="w-100" onClick={handleSaveChanges} > Save Changes</Button>
          {/* :<Button variant="primary"  onClick={handleSaveChanges} > Save Changes</Button> */}
          {/* } */}
          </div>
                  </Form.Group>
                  </Row>
                </Form>
          <ConfirmIt
          Message={alertMessage}
          ShowConfirm={showConfirm}
          OnClose={() => setShowConfirm(false)}
          // onConfirm={confirmActionHandler}
          onConfirm={confirmAction}
        />
      <ToastIt
        Variance={variance}
        Message={toastMessage}
        ShowToast={showToast}
        OnClose={() => setShowToast(false)}
      />
      {/* <ConfirmIt
        Message={alertMessage}
        ShowConfirm={showConfirm}
        OnClose={() => setShowConfirm(false)}
        onConfirm={confirmActionHandler}
      /> */}
      <CSVLink
        className="btn btn-primary p-2 my-5 text-center w-100"
        data={csvData}
        filename={"GhanaBundles-admin-products.csv"}
        onClick={handleExportToCSV}
      >
        Export to Excel
      </CSVLink>
    </Container>
  );
};

export default AdminProducts;
